import { useTranslate } from '@tolgee/react';
import { Card, Typography } from 'antd';

type Props = {
  message: string;
  onOk: () => void;
};

export const CardError: React.FC<Props> = ({ message, onOk }) => {
  const { t } = useTranslate();
  return (
    <Card size={'small'} className={'w-max absolute bottom-10 left-0 right-0 ml-auto mr-auto z-10'}>
      <div className={'flex justify-between gap-1 items-center'}>
        <Typography.Text>{t(`${message} `)}</Typography.Text>
        <Typography.Text className={'font-bold'} onClick={onOk}>
          {t('OK')}
        </Typography.Text>
      </div>
    </Card>
  );
};
